<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="paint_warning_linear" x1="11.92" y1="2.5" x2="11.92" y2="21.5" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="#FFE111"/>
      <stop offset="100%" stop-color="#FFA100"/>
    </linearGradient>
    <filter id="warning_glow" x="-20%" y="-20%" width="140%" height="140%">
      <feDropShadow dx="0" dy="0" stdDeviation="0.8" flood-color="#FFA000" flood-opacity="0.5"/>
    </filter>
  </defs>
  <g filter="url(#warning_glow)">
    <path
      d="M5.277 10.688C8.175 5.548 9.624 2.978 11.92 2.978c2.296 0 3.745 2.57 6.643 7.71l.361.64c2.41 4.27 3.615 6.406 2.526 7.967-1.089 1.562-3.783 1.562-9.17 1.562h-.723c-5.387 0-8.081 0-9.17-1.562C1.3 17.734 2.507 15.598 4.916 11.328l.361-.64Z"
      stroke="url(#paint_warning_linear)"
      stroke-width="2.2"
      stroke-linejoin="round"
    />
    <path
      d="M11.92 7.6v5"
      stroke="url(#paint_warning_linear)"
      stroke-width="2.2"
      stroke-linecap="round"
    />
    <circle
      cx="11.92"
      cy="16"
      r="1.2"
      fill="url(#paint_warning_linear)"
    />
  </g>
</svg>
